// extracted by mini-css-extract-plugin
export default {"symphonyBuyBoxPageContentCart":"TG-z","atcContainer":"UG-z","atcWrapper":"VG-z","disableClick":"WG-z"};